/**
 * @fileoverview Централизованные типы пункта аренды согласно STYLEGUIDE.md
 * Унифицированные типы для устранения дублирования RentalPoint
 */

import type { BaseEntity } from './index';

// Frontend тип (camelCase) - централизованный RentalPoint
export interface RentalPoint extends BaseEntity {
  name: string;
  address: string;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  openTime?: string | null;
  closeTime?: string | null;
  isActive: boolean;
}

// Database тип (snake_case)
export interface DbRentalPoint {
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  name: string;
  address: string;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  open_time?: string | null;
  close_time?: string | null;
  is_active: boolean;
}

// Маппинг DB -> Frontend (согласно STYLEGUIDE.md)
export const dbRentalPointToRentalPoint = (dbRentalPoint: DbRentalPoint): RentalPoint => ({
  id: dbRentalPoint.id,
  userId: dbRentalPoint.user_id,
  createdAt: new Date(dbRentalPoint.created_at),
  updatedAt: new Date(dbRentalPoint.updated_at),
  name: dbRentalPoint.name,
  address: dbRentalPoint.address,
  phone: dbRentalPoint.phone,
  email: dbRentalPoint.email,
  website: dbRentalPoint.website,
  openTime: dbRentalPoint.open_time,
  closeTime: dbRentalPoint.close_time,
  isActive: dbRentalPoint.is_active,
});

// Маппинг Frontend -> DB (согласно STYLEGUIDE.md)
export const rentalPointToDbRentalPoint = (rentalPoint: RentalPoint): Omit<DbRentalPoint, 'created_at' | 'updated_at'> => ({
  id: rentalPoint.id,
  user_id: rentalPoint.userId,
  name: rentalPoint.name,
  address: rentalPoint.address,
  phone: rentalPoint.phone,
  email: rentalPoint.email,
  website: rentalPoint.website,
  open_time: rentalPoint.openTime,
  close_time: rentalPoint.closeTime,
  is_active: rentalPoint.isActive,
});

// Тип для создания пункта аренды
export type RentalPointCreate = Omit<RentalPoint, 'id' | 'createdAt' | 'updatedAt'>;

// Тип для обновления пункта аренды
export type RentalPointUpdate = Partial<Omit<RentalPoint, 'id' | 'userId' | 'createdAt' | 'updatedAt'>>;

// Тип для DB операций создания
export type DbRentalPointInsert = Omit<DbRentalPoint, 'id' | 'created_at' | 'updated_at'>;

// Тип для DB операций обновления
export type DbRentalPointUpdate = Partial<Omit<DbRentalPoint, 'id' | 'user_id' | 'created_at' | 'updated_at'>>;

// Упрощенный тип для селекторов (только основные поля)
export interface RentalPointOption {
  id: string;
  name: string;
  address?: string;
}
